module.exports = __webpack_public_path__ + "assets/img/img2-209e557b.png";